import { useMemo } from "react";
import { filterTranscripts, sortTranscripts } from "./utils";
import { useTranscriptsUI } from "./TranscriptsProvider";
import type { TranscriptListItem } from "@/types/transcript";

/**
 * The provider's search + sort applied to a transcript list. Shared by the
 * list pane and the page's keyboard navigation so they always agree on order.
 */
export function useFilteredTranscripts(transcripts: TranscriptListItem[] | undefined): TranscriptListItem[] {
	const { search, sortField, sortOrder } = useTranscriptsUI();

	return useMemo(
		() => sortTranscripts(filterTranscripts(transcripts || [], search), sortField, sortOrder),
		[transcripts, search, sortField, sortOrder]
	);
}
